import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import cartIcon from '../../assets/icons/k-cart-ico.svg';

const LinkInner = styled.div`

position: absolute;
display: block;
width: 50px;
height: 25px;
top: 0px;
left: 0px;
.k-cart-ico{
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, calc(-50% - 2px));
    display: block;
    width: 30px;
    height: 15px;
    transition: transform 0.1s ease-in-out;
    background-color: #fff;
    -webkit-mask-image: url("${cartIcon}");
    mask-image: url("${cartIcon}");
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
}

&:hover{
    .k-cart-ico{
    background-color: #009A49;
    }
}

`;

export default function Quote({ className, count }) {

    return <Link 
        // className={`relative justify-self-end mt-4 px-8 py-2 leading-none uppercase font-semibold text-secondary border border-secondary bg-white rounded-full shadow-lg hover:bg-secondary hover:text-white md:mt-0  ${className}`}
        className={`relative justify-self-end px-4 py-2 leading-none font-semibold border border-white rounded-lg text-white group hover:bg-white  ${className}`}
        style={{position: `relative`, width: `50px`, height: `25px`}}
        to="/quote"
        aria-label="View Basket">
        <LinkInner>
        <span class="k-cart-ico"></span>
            {count
                ? <span
                    style={{top: '-5px', right: '-5px'}}
                    className={`absolute w-5 h-5 bg-secondary text-white text-xxs rounded-full overflow-hidden text-center leading-5`}
                    aria-label={`you have ${count} quote item${count > 1 ? 's' : ''}`}>{count}</span> 
                : ''
            }
        </LinkInner>    
        </Link>

}